export default "__VITE_ASSET__CKrt0c0S__"